export const SET_LOCATION = 'SET_LOCATION';

// Actions
export const setLocation = (location) => ({
  type: SET_LOCATION,
  location,
});

// Selectors
export const getLocation = (state) => state.location;

// Reducer
const INITIAL_STATE = {};

const modalState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOCATION:
      // console.log(action, state);
      return {
        ...action.location,
      };
    default:
      return state;
  }
};
export default modalState;
